import { z } from 'zod';

const schema = z.object({
  VITE_API_URL: z.url(),
  VITE_APP_NAME: z.string().default('NT App'),
  // `z.stringbool()` aceita 'true'/'false'/'1'/'0'/'yes'/'no'/'on'/'off' e
  // devolve boolean. NÃO usar `z.coerce.boolean()` aqui: ele aplica
  // `Boolean(string)`, que converte qualquer string não-vazia (incluindo
  // 'false') para `true` — pegadinha clássica com env vars.
  VITE_DEV_IMPERSONATION_ENABLED: z.stringbool().default(false),
  VITE_SENTRY_DSN: z.string().optional(),
});

const parsed = schema.safeParse(import.meta.env);
if (!parsed.success) {
  console.error('❌ Invalid env:', z.treeifyError(parsed.error));
  throw new Error('Invalid environment variables');
}

export const env = parsed.data;

export const isDev = import.meta.env.DEV;
export const isProd = import.meta.env.PROD;
export const mode = import.meta.env.MODE;
